import React from 'react';
import { MapPin } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <footer className="bg-gray-900 text-white py-16">
      <div className="container mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12">
          {/* Company Info */}
          <div className="md:col-span-2">
            <img
              src="https://customer-assets.emergentagent.com/job_pmi-invest/artifacts/tuz22l37_Logo%20AEH_2.2.png"
              alt="Alfa Equity Holding"
              className="h-12 w-auto mb-6 bg-white p-2 rounded"
            />
            <p className="text-gray-400 leading-relaxed mb-6">
              Partner affidabile per la successione e lo sviluppo delle PMI. 
            
            </p>
            <div className="space-y-3">
              <div className="flex items-center space-x-3">
                <MapPin className="text-blue-400" size={20} />
                <span className="text-gray-300">Gentilino, Collina d'Oro, Svizzera</span>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-bold text-lg mb-4">Link rapidi</h3>
            <ul className="space-y-2">
              <li>
                <button
                  onClick={() => scrollToSection('chi-siamo')}
                  className="text-gray-400 hover:text-white transition-colors"
                >
                  Chi siamo
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('processo')}
                  className="text-gray-400 hover:text-white transition-colors"
                >
                  Processo 
                </button>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="font-bold text-lg mb-4">Contatti</h3>
            <p className="text-gray-400 mb-4">
              Pronti a valutare la vostra azienda?
            </p>
            <button
              onClick={() => scrollToSection('contatti')}
              className="bg-blue-900 text-white px-6 py-3 rounded-lg font-semibold hover:bg-blue-800 transition-all duration-300 hover:shadow-lg"
            >
              Contattaci
            </button>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-gray-400 text-sm">
              © {currentYear} Alfa Equity Holding. Tutti i diritti riservati.
            </p>
            <div className="flex space-x-6">
              <a href="#" className="text-gray-400 hover:text-white transition-colors text-sm">
                Privacy Policy
              </a>
              <a href="#" className="text-gray-400 hover:text-white transition-colors text-sm">
                Termini e Condizioni
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;